import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';

import auth from './modules/auth';
import ui from './modules/ui';
import routingProfiles from './modules/routing-profiles';
import users from './modules/users';
import voip from './modules/voip';
import live from './modules/live';
import courses from './modules/courses';
import directories from './modules/directories';
import planification from './modules/planification';
import settings from './modules/settings';

Vue.use(Vuex);

/**
 * Persist auth credentials in session storage
 */
const vuexPersistSession = new VuexPersistence({
  strictMode: true,
  storage: sessionStorage,
  reducer: state => {
    return {
      auth: state.auth,
    };
  },
});

/**
 * Persist filters in the local storage
 */
const vuexPersistLocalStorage = new VuexPersistence({
  strictMode: true,
  storage: localStorage,
  reducer: state => {
    return {
      live: {
        mapFilters: state.live.mapFilters,
        recentlyUsedMapFilters: state.live.recentlyUsedMapFilters,
      },
      courses: {
        selectedStationFilter: state.courses.selectedStationFilter,
      },
    };
  },
});

const store = new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  state: {},
  mutations: {
    RESTORE_MUTATION: vuexPersistSession.RESTORE_MUTATION,
  },
  actions: {},
  modules: {
    auth,
    ui,
    routingProfiles,
    users,
    voip,
    live,
    courses,
    directories,
    planification,
    settings,
  },
  plugins: [vuexPersistSession.plugin, vuexPersistLocalStorage.plugin],
});

export default store;
